import "izimodal";

export default {
  init() {

    const $modal = $("#RegisterModal");
    const $doc = $(document);

    $modal.iziModal({
      width: 768,
      overlayColor: 'rgba(0, 0, 0, 0.8)',
    });
    $doc.on('click', '#RegisterModalTrigger', function(e) {
      e.preventDefault();
      $modal.iziModal('open');
    });


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/portalLogin.js